import React from 'react';
import { useDrop } from 'react-dnd';

// Components
import DraggableLead from './DraggableLead';
import LeadCard from './LeadCard';

// Styles
import styles from './Leads.module.scss';

const StageColumn = ({ items=[], columnIndex, handleMoveMyLead, onSelectLead }) => {
    const [{ isOver, canDrop }, dropRef] = useDrop({
        accept: 'lead',
        hover(card, monitor) {
            if (!dropRef.current) {
                return;
            }
            const dragIndex = card.index;
            const hoverIndex = columnIndex;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = dropRef.current?.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            card.columnIndex = hoverIndex;
        },
        drop: card => {
            const from = { columnIndex: card.columnIndex, index: card.index, item: card.item};
            const to = { columnIndex };
            handleMoveMyLead(from, to);
        },
        canDrop: item => item.columnIndex !== columnIndex,
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        }),
    });

    return (
        <div
            className={ styles.stage }
            ref={dropRef}
            style={{ backgroundColor: isOver && canDrop ? 'rgba(179, 181, 189, 0.3)' : 'transparent' }}>
            {
                items.map((item, index) => {
                    const propsToDraggableCard = { item, columnIndex, index };

                    return (
                        <DraggableLead
                            className={ `${ styles.card } ${ styles[columnIndex] }` }
                            key={`${columnIndex} ${index} ${item}`}
                            onSelectLead={ onSelectLead }
                            { ...propsToDraggableCard }
                        />
                    )
                })
            }
            { isOver && canDrop ? <LeadCard empty /> : ""}
        </div>
    )
}

export default StageColumn;
